// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"446f5798","952":"b3f4784a"}[chunkId] + ".chunk.js";
};